import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { 
  Building2, 
  MapPin, 
  Car, 
  LayoutDashboard, 
  LogOut, 
  Menu, 
  X,
  ChevronDown,
  MessageCircle,
  Globe
} from 'lucide-react';

const menuItems = [
  { 
    path: '/admin', 
    label: 'Dashboard', 
    icon: LayoutDashboard 
  },
  { 
    path: '/admin/cities', 
    label: 'İller', 
    icon: Building2 
  },
  { 
    path: '/admin/districts', 
    label: 'İlçeler', 
    icon: Building2 
  },
  { 
    path: '/admin/neighborhoods', 
    label: 'Mahalleler', 
    icon: MapPin 
  },
  { 
    path: '/admin/taxi-stands', 
    label: 'Taksi Durakları', 
    icon: Car 
  },
  {
    path: '/admin/reviews',
    label: 'Yorumlar',
    icon: MessageCircle
  },
  {
    path: '/admin/seo',
    label: 'SEO Ayarları',
    icon: Globe
  }
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  const toggleSidebar = () => setIsMenuOpen(!isMenuOpen);

  const handleLogout = () => {
    // Çıkış işlemleri burada yapılacak
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Sidebar */}
      <aside 
        className={`fixed top-0 left-0 z-40 h-screen transition-transform ${
          isMenuOpen ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0`}
      >
        <div className="h-full px-3 py-4 overflow-y-auto bg-gray-800 w-64">
          <div className="flex items-center justify-between mb-6 px-2">
            <Link to="/admin" className="flex items-center gap-2">
              <Car className="w-8 h-8 text-yellow-400" />
              <span className="text-xl font-bold text-white">TaksiDurak</span>
            </Link>
            <button 
              onClick={toggleSidebar}
              className="md:hidden text-gray-400 hover:text-white"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive 
                      ? 'bg-yellow-400 text-gray-900' 
                      : 'text-gray-400 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>
      </aside>

      {/* Main Content */}
      <div className={`${isMenuOpen ? 'md:ml-64' : ''} p-4 md:p-8`}>
        {/* Header */}
        <header className="mb-8">
          <div className="flex items-center justify-between">
            <button
              onClick={toggleSidebar}
              className="md:hidden text-gray-400 hover:text-white"
            >
              <Menu className="w-6 h-6" />
            </button>

            <div className="relative ml-auto">
              <button
                onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                className="flex items-center gap-2 text-gray-400 hover:text-white"
              >
                <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center">
                  <span className="text-sm font-medium">AY</span>
                </div>
                <span>Admin</span>
                <ChevronDown className="w-4 h-4" />
              </button>

              {isProfileMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-gray-800 rounded-lg shadow-lg py-2">
                  <button
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-left text-gray-400 hover:bg-gray-700 hover:text-white flex items-center gap-2"
                  >
                    <LogOut className="w-4 h-4" />
                    <span>Çıkış Yap</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}